package com.vizio.redwolf.pay.client

import com.vizio.redwolf.utils.ClientConfig
import io.ktor.client.HttpClient

abstract class PayApiHttpClient(clientConfig: ClientConfig) {
    protected val httpClient: HttpClient = clientConfig.clientProvider.httpClient
}
